import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
    isUser:0, //是否有用户信息
    isSowLogin:0, //是否显示登录框
    funLogin:()=>{}, //登录回调函数
		 location: null,        // 当前定位 {lat, lng, address}
		  isLocationLocked: false, // 是否锁定定位
		  address: null  // 当前地址
	},
	mutations: {
		 SET_LOCATION(state, payload) {
		    state.location = payload;
		    // uni.setStorageSync('cachedLocation', payload);
		  },
		  LOCK_LOCATION(state) {
		    state.isLocationLocked = true;
		    // uni.setStorageSync('locationLocked', true);
		  },
		 SET_ADDRESS(state, payload) {
			 state.address = payload;
		 }
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js